import * as api from '@/store/api';
import {ReceivedMessageFromFaxServiceDto} from '@/store/models/LetterOwner/RecievedMessageFromFaxServiceDto'
import File from '@/store/models/Letter/File';



export async function getAllFaxAndEmails(): Promise<ReceivedMessageFromFaxServiceDto[]>{
    try {
        const serverResult =  await api.batisAutomationApi.post("/faxes/All");
        return serverResult.data as ReceivedMessageFromFaxServiceDto[];
    } 
    catch (error) {
        console.log(error);
        return {} as ReceivedMessageFromFaxServiceDto[];    
    }
}

export async function getFaxFile(fileId: string): Promise<File>{
    try {
        const serverResult =  await api.batisAutomationApi.post("/faxes/file", {fileId: fileId});
        return serverResult.data as File;
    } 
    catch (error) {
        console.log(error);
        return {} as File;    
    }
}

export async function deleteFax(faxId: string){
    try {
        const serverResult =  await api.batisAutomationApi.post("/faxes/delete", {faxId: faxId});
        
    } 
    catch (error) {
        console.log(error);
        return {} as File;    
    }
}

export async function routMessage(messageId: string, ownerId: string){
    try {
        const serverResult =  await api.batisAutomationApi.post("/faxes/routmessage", {companyOwnerId: ownerId, messageId: messageId});
        
    } 
    catch (error) {
        console.log(error);
        return {} as File;    
    }
}